import { useApi } from "../../api/hooks/use-api.ts";
import { ApiResponseType } from "../../api/types.ts";
import { ApiMethod } from "../../api/types.ts";
import { asObject } from "../../api/payload.ts";

let pricesCache: any = null;

export const usePricesApi = () => {
    const { sendProtectedRequest } = useApi();

    // Exam fees per exam-type field, resolved server-side from the configured
    // articles: { exam_type_efa_cfp: { net, gross }, ... }. Cached for the session.
    const getPrices = async () => {
        if (pricesCache) {
            return pricesCache;
        }
        const response = sendProtectedRequest(
            ApiMethod.GET,
            process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT +
            '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN +
            '&action=prices'
        );

        return response.then(data => {
            if (data.type === ApiResponseType.OK) {
                const parsed = asObject(data.payload);
                // Only cache a non-empty result, so an early empty response (addon not yet
                // deployed / articles not configured) does not stick for the whole session.
                if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
                    pricesCache = parsed;
                }
                return parsed;
            }
            return {};
        });
    };

    // Next upcoming exam: { exam_date, registration_deadline, registration_open,
    // allowed_exam_types, linked_exam_number } (timestamps in unix seconds), or null
    // when no upcoming exam project exists. Rejects on a failed request so callers
    // can tell "no exam" from "could not load" (see examRegistration.ts).
    const getNextExam = async () => {
        const response = sendProtectedRequest(
            ApiMethod.GET,
            process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT +
            '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN +
            '&action=nextExam'
        );

        return response.then(data => {
            if (data.type !== ApiResponseType.OK) {
                throw new Error('nextExam request failed');
            }
            // Parsed centrally; a JSON `null` body means no upcoming exam project.
            return (data.payload && typeof data.payload === 'object') ? data.payload : null;
        });
    };

    return { getPrices, getNextExam };
};
